import { Component, HostListener, OnInit } from "@angular/core";

import { environment } from "../environments/environment";
import { DataService } from "./pages/shared/data.service";
import { AuthService } from "./core/auth/auth.service";
import { StorageService } from "./core/helpers/storage-Service";
import { PosthogService } from "./core/services/posthog.service";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    private payserv: DataService,
    private authService: AuthService,
    private storageService: StorageService,
    posthogService: PosthogService,
    private router: Router,
  ) {}

  @HostListener("window:beforeunload", ["$event"])
  clearsessionStorage(event) {
    this.storageService.removeStorage(); // Clear local storage when tab is closed
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes("collection")) {
          this.getCheckoutToken("payment", "Obinnanjokualphabetallpcom");
        }
        // if (event.url.includes("invoice")) {
        //   const id = event.url.split("/").pop();

        //   this.getCheckoutToken("invoice", "payment", id);
        // }
      }
    });
    // this.setBaseUrl();
    // this.authService.getAccessControl().subscribe((data) => {
    //   this.storageService.saveAccessToken(data);
    // });
  }

  setBaseUrl() {
    if (location.href.includes("/gh/")) {
      this.payserv.setBaseUrlState(environment.ghurl);
    } else {
      this.payserv.setBaseUrlState(environment.url);
    }
  }

  getCheckoutToken(
    entityType?: string,
    clientId?: string,
    reference: string = "123",
  ) {
    return this.authService
      .getAccessControl(entityType, clientId, reference)
      .subscribe((res) => {
        this.storageService.saveAccessToken(res["token"]);
      });
  }
}
